import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core'
import { NbDialogRef, NbDialogService } from '@nebular/theme'
import { EmployeeService } from '../../@core/services/employee.service'
import { SharedService } from '../../@core/services/shared.service'
import { CDK_DRAG_CONFIG, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop'
const DragConfig = {
    dragStartThreshold: 0,
    pointerDirectionChangeThreshold: 5,
    zIndex: 10000,
}
@Component({
    templateUrl: './employee-sorting.component.html',
    styleUrls: ['./employee-sorting.component.scss'],
    selector: 'app-single-employee-picker',
    providers: [{ provide: CDK_DRAG_CONFIG, useValue: DragConfig }],
})
export class EmployeeSortingComponent implements OnInit {
    @Input() employeeList: Array<any>
    @Output() sortedEmployeeList: Array<any>
    dataSource: Array<any>
    protected dialogRef: NbDialogRef<any>

    constructor(
        public sharedService: SharedService,
        public employeeService: EmployeeService,
        dialogRef: NbDialogRef<any>
    ) {
        this.dialogRef = dialogRef
    }

    ngOnInit() {
        this.dataSource = this.employeeList || []
    }
    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.dataSource, event.previousIndex, event.currentIndex)
    }

    onOk() {
        this.dialogRef.close(this.dataSource)
    }
    onCancel() {
        this.dialogRef.close()
    }
}
